export const SalesOption = {
	plugins: {
		legend: {
			display: false
		},
		tooltip: {
			boxWidth: 15,
			bodyFont: {
				size: 14
			}
		}
	},
	layout: {
		padding: {
			right: 40
		}
	},
	scales: {
		xAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				beginAtZero: true, // 0부터 시작
				maxRotation: 0,
				minRotation: 0,
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value;
				}
			},
			gridLines: {
				display: false,
			}
		}],
		yAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				autoSkipPadding: 50,
				beginAtZero: true,
				min: 0,
				max: 200,
				stepSize: 100,
				maxRotation: 0, // 최대 기울기
				minRotation: 0, // 최소 기울기
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value;
				}
			},
			gridLines: {
				color: '#595D69',
				drawBorder: false,
				zeroLineColor: '#595D69',
			}
		}]
	},
	responsive: true,
	showTooltips: true,
	maintainAspectRatio: true,
	animation: {
		duration: 2500
	}
};

export const searchChartOption = {
	maintainAspectRatio: false,
	responsive: true,
	showTooltips: true,
	legend: {
		display: false
	},
	scales: {
		xAxes: [{
			stacked: true,
			ticks: {
				autoSkip: true,
				autoSkipPadding: 150,
				beginAtZero: true, // 0부터 시작
				maxRotation: 0,
				minRotation: 0,
				callback: function(value, index, values) {
					return value;
				}
			},
		}],
		yAxes: [{
			stacked: true,
			ticks: {
				autoSkip: true,
				autoSkipPadding: 50,
				beginAtZero: true,
				maxRotation: 0, // 최대 기울기
				minRotation: 0, // 최소 기울기
				callback: function(value, index, values) {
					return value + '人';
				}
			},
			gridLines: {
				display: false,
			}
		}]
	},
	tooltips: {
		bodySpacing: 15,
		// mode: 'nearest',
		// yAlign: 'bottom',
		titleFontSize: 7,
    bodyFontSize: 7
	}
	// cutoutPercentage: 65 // line 굵기
};

export const VisitorOption = {
	layout: {
		padding: {
			right: 40
		}
	},
	maintainAspectRatio: true,
	responsive: true,
	showTooltips: true,
	legend: {
		display: false
	},
	scales: {
		xAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				beginAtZero: true, // 0부터 시작
				maxRotation: 0,
				minRotation: 0,
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value;
				}
			},
			gridLines: {
				display: false,
			}
		}],
		yAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				autoSkipPadding: 50,
				beginAtZero: true,
				min: 0,
				max: 200,
				stepSize: 100,
				maxRotation: 0, // 최대 기울기
				minRotation: 0, // 최소 기울기
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value + '人';
				}
			},
			gridLines: {
				color: '#595D69',
				drawBorder: false,
				zeroLineColor: '#595D69',
			}
		}]
	},
	tooltips: {
		bodySpacing: 15,
		// mode: 'nearest',
		// yAlign: 'bottom',
    callbacks: {
      title: function(item) {
        console.log(item)
        if(item[0].datasetIndex == 0) { //acquisition
          return '取得数';
        } else {
          return '未取得数';
        }
      }
    },
	}
	// plugins: {
	// 	datalabels: {
	// 		color: 'white',
	// 		font: {
	// 			weight: 'bold'
	// 		},
	// 		formatter: function(value, context) {
	// 			return Math.round(value) + '%';
	// 		}
	// 	}
	// }
	// cutoutPercentage: 65 // line 굵기
};

export const GenderChartOption = {
	layout: {
		padding: {
			right: 40
		}
	},
	maintainAspectRatio: true,
	responsive: true,
	showTooltips: true,
	legend: {
		display: false
	},
	scales: {
		xAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				beginAtZero: true, // 0부터 시작
				maxRotation: 0,
				minRotation: 0,
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value;
				}
			},
			gridLines: {
				display: false,
			},
			// afterFit: function(scale) {
			// 	scale.height = 200  //<-- set value as you wish 
		 	// },
		}],
		yAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				autoSkipPadding: 50,
				beginAtZero: true,
				min: 0,
				max: 100,
				stepSize: 50,
				maxRotation: 0, // 최대 기울기
				minRotation: 0, // 최소 기울기
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value + '人';
				}
			},
			gridLines: {
				color: '#595D69',
				drawBorder: false,
				zeroLineColor: '#595D69',
			}
		}]
	},
	tooltips: {
		bodySpacing: 15,
		// mode: 'nearest',
		// yAlign: 'bottom',
    callbacks: {
      title: function(item) {
        console.log(item)
        if(item[0].datasetIndex == 0) { //man
					return '女性';
        } else {
					return '男性';
        }
      }
    }
	}
	// cutoutPercentage: 65 // line 굵기
};

export const RepeaterChartOption = {
	layout: {
		padding: {
			right: 40
		}
	},
	maintainAspectRatio: true,
	responsive: true,
	showTooltips: true,
	legend: {
		display: false
	},
	scales: {
		xAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				beginAtZero: true, // 0부터 시작
				maxRotation: 0,
				minRotation: 0,
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value;
				}
			},
			gridLines: {
				display: false,
			}
		}],
		yAxes: [{
			stacked: true,
			ticks: {
				fontSize: 15,
				autoSkip: true,
				autoSkipPadding: 50,
				beginAtZero: true,
				min: 0,
				max: 150,
				stepSize: 75,
				maxRotation: 0, // 최대 기울기
				minRotation: 0, // 최소 기울기
				fontColor: '#D1D1D1',
				callback: function(value, index, values) {
					return value + '人';
				}
			},
			gridLines: {
				color: '#595D69',
				drawBorder: false,
				zeroLineColor: '#595D69',
			}
		}]
	},
	tooltips: {
		bodySpacing: 15,
		// mode: 'nearest',
		// yAlign: 'bottom',
    callbacks: {
      title: function(item) {
        console.log(item)
        if(item[0].datasetIndex == 1) { //repeatCustomer
          return 'リピーター';
        } else {
          return '新規';
        }
      }
    }
	}
	// cutoutPercentage: 65 // line 굵기
};